import React from 'react'

import { Typography, Box } from '@material-ui/core'

import ItemStatus, { ItemStatusProps } from './ItemStatus'

export interface lineDescription {
  lineTariffName: string
  lineNumber: string
}

export interface CheckoutItemProps {
  line: lineDescription
  status: ItemStatusProps
  dataHook: string
}

export default function CheckoutItem({ line, status, dataHook }: CheckoutItemProps) {
  const { lineTariffName, lineNumber } = line
  const { type, text, actions, tooltipMessage } = status
  return lineTariffName && lineNumber && type && text ? (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      my={3}
      data-hook={dataHook}
      data-status={type}
    >
      <Box flexBasis="35%" display="inline-flex" mr={11}>
        <Box mr={3}>
          <Typography variant="h4">{lineTariffName}</Typography>
        </Box>

        <Box mr={3}>
          <Typography variant="h4">|</Typography>
        </Box>

        <Box>
          <Typography variant="h4">{lineNumber}</Typography>
        </Box>
      </Box>

      <Box flexBasis="65%" display="inline-flex">
        <ItemStatus type={type} text={text} actions={actions} tooltipMessage={tooltipMessage} />
      </Box>
    </Box>
  ) : null
}
